const CACHE_LIMIT = 1000 * 60 * 60; // 1 hour

const STORAGE_KEY = 'MIRAI:USER:BOOKINGS';

const TRACKING = 'BOOKINGS';

export { CACHE_LIMIT, STORAGE_KEY, TRACKING };
